/* ================================================
   NAV — transparent until scrolled
   ================================================ */
const nav = document.getElementById('site-nav');
window.addEventListener('scroll', () => {
  nav.classList.toggle('is-scrolled', window.scrollY > 48);
}, { passive: true });

/* ================================================
   MOBILE NAV TOGGLE
   ================================================ */
const navToggle = document.getElementById('nav-toggle');
const navDrawer = document.getElementById('nav-drawer');
let isNavOpen = false;

navToggle.addEventListener('click', () => {
  isNavOpen = !isNavOpen;
  navDrawer.classList.toggle('is-open', isNavOpen);
  navToggle.setAttribute('aria-expanded', String(isNavOpen));
  const spans = navToggle.querySelectorAll('span');
  if (isNavOpen) {
    spans[0].style.transform = 'translateY(6.5px) rotate(45deg)';
    spans[1].style.transform = 'translateY(-6.5px) rotate(-45deg)';
  } else {
    spans[0].style.transform = '';
    spans[1].style.transform = '';
  }
});

// Close drawer on link click
navDrawer.querySelectorAll('a').forEach(a => {
  a.addEventListener('click', () => {
    isNavOpen = false;
    navDrawer.classList.remove('is-open');
    navToggle.setAttribute('aria-expanded', 'false');
    navToggle.querySelectorAll('span').forEach(s => s.style.transform = '');
    navDrawer.removeEventListener('keydown', trapNavFocus);
    navToggle.focus();
  });
});

// Focus trap for mobile nav drawer
const FOCUSABLE_SEL = 'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])';
function trapNavFocus(e) {
  if (e.key !== 'Tab') return;
  const focusable = Array.from(navDrawer.querySelectorAll(FOCUSABLE_SEL));
  if (!focusable.length) return;
  const first = focusable[0], last = focusable[focusable.length - 1];
  if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
}
navToggle.addEventListener('click', () => {
  if (isNavOpen) {
    navDrawer.addEventListener('keydown', trapNavFocus);
    const firstFocusable = navDrawer.querySelector(FOCUSABLE_SEL);
    if (firstFocusable) firstFocusable.focus();
  } else {
    navDrawer.removeEventListener('keydown', trapNavFocus);
    navToggle.focus();
  }
});

// /* Scroll reveal */
// const revealObserver = new IntersectionObserver((entries) => {
//   entries.forEach(entry => {
//     if (entry.isIntersecting) entry.target.classList.add('is-visible');
//   });
// }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
// document.querySelectorAll('.reveal, .reveal-scale, .reveal-number').forEach(el => {

//   revealObserver.observe(el);
// });

/* ================================================
   SCROLL REVEAL
   ================================================ */

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) entry.target.classList.add('is-visible');
  });
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
document.querySelectorAll('.reveal, .reveal-scale, .reveal-left, .reveal-number').forEach(el => {
  revealObserver.observe(el);
});

/* ================================================
   SUB-NAV — show after hero leaves viewport
   ================================================ */
const pdpSubnav  = document.getElementById('pdp-subnav');
const heroSection = document.getElementById('hero');
if (heroSection && pdpSubnav) {
  const stickyObs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      pdpSubnav.classList.toggle('is-visible', !e.isIntersecting);
    });
  }, { threshold: 0 });
  stickyObs.observe(heroSection);
}

/* ================================================
   SUB-NAV — active link on scroll
   ================================================ */
const subnavLinks = document.querySelectorAll('.pdp-subnav-link');
const subnavSections = Array.from(subnavLinks).map(l => {
  const id = l.getAttribute('href').replace('#', '');
  return document.getElementById(id);
}).filter(Boolean);

// Track intersection ratios; activate whichever section has the most visible area
const subnavRatios = new Map();
const subnavSetActive = () => {
  let best = null, bestRatio = 0;
  subnavRatios.forEach((ratio, el) => {
    if (ratio > bestRatio) { bestRatio = ratio; best = el; }
  });
  subnavLinks.forEach(l => {
    l.classList.toggle('is-active', best && l.getAttribute('href') === `#${best.id}`);
  });
};

const subnavActiveObs = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    subnavRatios.set(e.target, e.intersectionRatio);
  });
  subnavSetActive();
}, { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1], rootMargin: '-72px 0px -20% 0px' });

subnavSections.forEach(s => { subnavRatios.set(s, 0); subnavActiveObs.observe(s); });


/* About Hero Banner parallax */
(function () {
  const img = document.querySelector('.about-hero-bg img');
  if (!img) return;
  window.addEventListener('scroll', () => {
    img.style.transform = `translateY(${window.scrollY * 0.22}px)`;
  }, { passive: true });
})();


/* Scroll position correction becuase of animation  */
(function() {
  // Get the current position of the element
  function getElementPosition(element) {
    return element.getBoundingClientRect().top + window.scrollY;
  }
  
  // Scroll to a specific position
  function scrollToPosition(position) {
    window.scrollTo({
      top: position,
      behavior: 'smooth'
    });
  }
  
  // Main logic: Let browser scroll, then check and correct
  function handleHashLink(element) {
    if (!element) return;
    
    // Step 1: Get position BEFORE browser scroll
    const beforePosition = getElementPosition(element);
    //console.log('Position before scroll:', beforePosition);
    
    // Step 2: Let browser do its default scroll
    // Wait for scroll to complete
    setTimeout(() => {
      // Step 3: Get position AFTER browser scroll
      const afterPosition = getElementPosition(element);
      //console.log('Position after scroll:', afterPosition);
      
      // Step 4: If positions are different, scroll to the new position
      if (beforePosition !== afterPosition) {
        const difference = afterPosition - beforePosition;
        //console.log(`Element shifted ${difference}px. Scrolling to corrected position...`);
        
        // Step 5: Scroll to the updated position
        scrollToPosition(afterPosition);
      } else {
        console.log('No shift detected');
      }
    }, 1000); // Wait 1 second for animations to complete
  }
  
  // Listen for clicks on hash links
  document.body.addEventListener('click', function(e) {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;
    
    const href = link.getAttribute('href');
    if (!href || href === '#') return;
    
    const targetId = href.substring(1);
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      e.preventDefault();
      
      // Update URL
      history.pushState(null, null, href);
      
      // Let browser jump to element
      targetElement.scrollIntoView();
      
      // Then check and correct position
      handleHashLink(targetElement);
    }
  });
  
  // Handle page load with hash in URL
  if (window.location.hash && window.location.hash !== '#') {
    const targetId = window.location.hash.substring(1);
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      window.addEventListener('load', function() {
        setTimeout(() => {
          handleHashLink(targetElement);
        }, 500);
      });
    }
  }
})();